module.exports = __webpack_public_path__ + "img/close.477c0b12.svg";